import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store/store";
import { ref, onMounted, onUpdated } from "vue";
import Navigation from "../../NavigationContainer.vue";
import PcUploadArea from "@/components/scan/pc/PcUploadArea.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import PcFileDataService from "@/services/PcFileDataService";
import ResponseData from "@/types/ResponseData";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const alertState = ref("neutral");
const alertMessage = ref("null");
const destinationList = store.getters.stationListData;
const selectedDestination = ref("");

/** アラートの表示非表示切り替え */
const ChangeAlertState = (value) => {
  alertState.value = value;
};

/** アラート文切り替え */
const alertMessageValue = (value) => {
  alertMessage.value = value;
};

onMounted(function () {
  selectedDestination.value = selectedDestination.value == "" ? store.getters.selectedStation : selectedDestination.value;
  store.dispatch("setSelectedStation", selectedDestination.value);
  if (store.getters.fileFormatListData == null) {
    getFileFormatList();
  }
});

const getFileFormatList = () => {
  PcFileDataService.getFileFormatList()
    .then((response: ResponseData) => {
      store.dispatch("setFileFormatList", response.data);
    })
    .catch((e: Error) => {
      console.log(e);
    });
};

onUpdated(function () {
  store.dispatch("setSelectedStation", selectedDestination.value);
});

/** 拠点ごとのアップロード履歴をcsv出力する関数 */
const outputUploadHistoryByCSV = () => {
  const fromStationCode = {
    fromStationCode: selectedDestination.value,
  };
  PcFileDataService.getUploadHistory(fromStationCode)
    .then((response: ResponseData) => {
      let uploadHistoryCSV =
        "toStationCode,dataId,uploadDate&Time,uploadUserId,refNumber\n";
      response.data.forEach((el: { [x: string]: string }) => {
        var line =
          el["toStationCode"] +
          "," +
          el["dataId"] +
          "," +
          el["uploadDate"] +
          "," +
          el["uploadUserId"] +
          "," +
          el["refNumber"] +
          "\n";
        uploadHistoryCSV += line;
      });
      var blob = new Blob([uploadHistoryCSV], { type: "text/csv" });
      var link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = "upload_history_" + selectedDestination.value + ".csv";
      link.click();
    })
    .catch((e: Error) => {
      console.log(e);
    });
};

const __returned__ = { alertState, alertMessage, destinationList, selectedDestination, ChangeAlertState, alertMessageValue, getFileFormatList, outputUploadHistoryByCSV, store, Navigation, PcUploadArea, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})